















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'UserCoin'
})
export default class extends Vue {}
